/**
 * 海外请求接口方法
 * @author Mr.姜
 * @param http  封装的axios请求方式
 * @since 2021/07/07
 * */

import http from '@/api/http'

export default {
  /**
   * @returns 产品
   */
  // 获取产品列表
  getAppData () {
    return http.get(`/xsdk-wide/api/games`)
  },
  // 新增产品
  addProduct (params) {
    return http.post(`/xsdk-wide/api/games`, params)
  },
  // 删除产品
  deleteProduct (id) {
    return http.delete(`/xsdk-wide/api/games/${id}`)
  },
  // 修改产品
  changeProduct (data) {
    return http.put(`/xsdk-wide/api/games/${data.id}`, data)
  },
  // 货币查询
  getCurrencyData (params) {
    return http.get(`/xsdk-wide/api/games/products`, {params: params})
  },
  // 货币增改
  addOrChangeCurrency (params) {
    return http.put(`/xsdk-wide/api/games/products`, params)
  },

  /**
   * 渠道模块相关接口
   * @param type ‘login’为登录逻辑，‘pay’为支付逻辑
   * @param method http请求方式(get，post，put，delete)
   * @param params post时相关参数
   * @param id 用于 删除/修改
   * @param data put时所用参数
   * @returns {Promise<AxiosResponse<any>>|IDBRequest<IDBValidKey>|Promise<void>|*}
   */
  httpChannel ({type = 'login', method = 'get', params, id, data} = {}) {
    const url = `/xsdk-wide/api/${type}-channels`
    switch (method) {
      case 'get':
        return http.get(url, {params: params})
      case 'post':
        return http.post(url, params)
      case 'put':
        return http.put(`${url}/${params.id}`, params)
      case 'delete':
        return http.delete(`${url}/${id}`)
    }
  },
  // 获取渠道货币列表
  httpChannelCurrency ({method = 'get', params} = {}) {
    const url = `/xsdk-wide/api/pay-channels/products`
    switch (method) {
      case 'get':
        return http.get(url, {params: params})
      case 'put':
        return http.put(`${url}`, params)
    }
  },
  /**
   * 逻辑模块相关接口
   * @param type ‘login’为登录逻辑，‘pay’为支付逻辑
   * @param method http请求方式(get，post，put，delete)
   * @param params post时相关参数
   * @param id 用于 删除/修改
   * @param data put时所用参数
   * @returns {Promise<AxiosResponse<any>>|IDBRequest<IDBValidKey>|Promise<void>|*}
   */
  httpLogic ({type = 'login', method = 'get', params, id} = {}) {
    const url = `/xsdk-wide/api/${type}-logics`
    switch (method) {
      case 'get':
        return http.get(url)
      case 'post':
        return http.post(url, params)
      case 'put':
        return http.put(`${url}/${params.id}`, params)
      case 'delete':
        return http.delete(`${url}/${id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/other.js